import { useMemo } from "react";
import menuItems from "../menu-items";
import useAuth from "./useAuth";

const isMenuItemVisible = (item, roles, isAdmin) => {
  if (!item?.visible) return true;
  return item.visible(roles, isAdmin);
};

/** Apply visible() on nested collapse children (e.g. Bed Management sub-items). */
const filterVisibleMenuChildren = (children, roles, isAdmin) => {
  if (!children?.length) return [];

  return children
    .filter((child) => isMenuItemVisible(child, roles, isAdmin))
    .map((child) => {
      if (!child.children?.length) return child;
      const nested = filterVisibleMenuChildren(child.children, roles, isAdmin);
      return { ...child, children: nested };
    })
    .filter((child) => {
      if (child.type === "collapse" && Array.isArray(child.children)) {
        return child.children.length > 0;
      }
      return true;
    });
};

export default function useNavItems() {
  const { isAdmin, canAccess, roles } = useAuth();
  
  const items = useMemo(() => {
    // Get all accessible menu items based on user roles
    const filteredItems = menuItems.items
      .filter((item) => item.id && canAccess(item.id) && isMenuItemVisible(item, roles, isAdmin))
      .map((item) => {
        if (!item.children) return item;

        const children = filterVisibleMenuChildren(item.children, roles, isAdmin);
        return children.length > 0 ? { ...item, children } : null;
      })
      .filter(Boolean);

    return filteredItems;
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [isAdmin, canAccess, roles]);

  return items;
}